import { CreditScore } from '@/catalog/types/credit-score';
import FilterCreditDrawerDialog from '../filter-credit-drawer-dialog';
import { AgeRange } from '@/catalog/types/age-range';
import FilterPlanDrawerDialog from '../filter-plan-drawer-dialog';

export interface PlanAgeCreditPillsProps {
  creditScores: CreditScore[];
  selectedCreditScoreId?: string;
  ageRanges?: AgeRange[];
  selectedAgeRangeId?: string;
  selectedAge: boolean;
  canViewSwap?: boolean;
  canLegacySwap?: boolean;
  selectedPlanMileage?: number;
  mileagePlans: number[];
  planHandleClose: () => void;
  planOpen: boolean;
  planHandleOpen: () => void;
  planError?: string;
  creditHandleClose: () => void;
  creditOpen: boolean;
  creditHandleOpen: () => void;
  creditError?: string;
  hideCreditModal: boolean;
  fullstoryEventDelegate: (mileage: string) => void;
  pillClassName?: string;
}

export default function PlanAgeCreditPills({
  selectedPlanMileage,
  selectedCreditScoreId,
  selectedAgeRangeId,
  selectedAge,
  creditScores,
  ageRanges,
  canViewSwap = false,
  canLegacySwap = false,
  mileagePlans,
  planHandleClose,
  planOpen,
  planHandleOpen,
  planError,
  creditOpen,
  creditHandleOpen,
  creditHandleClose,
  creditError,
  hideCreditModal,
  fullstoryEventDelegate,
  pillClassName,
}: PlanAgeCreditPillsProps) {
  /**
   * Legacy swaps can see plan filters. However if not legacy, use the normal show/hide where swaps cannot filter plans */
  const showPlanFilter = (() => {
    if (canLegacySwap) {
      return true;
    }

    return !canViewSwap;
  })();

  return (
    <>
      {!canViewSwap && !hideCreditModal && (
        <FilterCreditDrawerDialog
          selectedCreditScoreId={selectedCreditScoreId}
          selectedIsOver25={selectedAge}
          creditScores={creditScores}
          ageRanges={ageRanges}
          selectedAgeRangeId={selectedAgeRangeId}
          open={creditOpen}
          error={creditError}
          handleClose={creditHandleClose}
          handleOpen={creditHandleOpen}
          pillClassName={pillClassName}
          dark={false}
          forceShorthandCopy={true}
        />
      )}

      {showPlanFilter ? (
        <FilterPlanDrawerDialog
          handleClose={planHandleClose}
          open={planOpen}
          handleOpen={planHandleOpen}
          error={planError}
          mileagePlans={mileagePlans}
          selectedPlanMileage={selectedPlanMileage}
          fullstoryEventDelegate={fullstoryEventDelegate}
          pillClassName={pillClassName}
          dark={false}
          showShorthandCopy={false}
        />
      ) : null}
    </>
  );
}
